import makeElementDraggable from './make-element-draggable'

function initDraggableModal(root) {
    let numberOfModalOpen = 0;

    if (root && root.$on) {
        // NOTE: Triggered when modal successfully rendered
        root.$on('bv::modal::shown', (bvEvent, modalId) => {

            // NOTE: get isDraggable attribute/prop from b-modal component
            const isDraggable =
                (bvEvent &&
                    bvEvent.vueTarget &&
                    bvEvent.vueTarget.$options &&
                    bvEvent.vueTarget.$options._parentVnode &&
                    bvEvent.vueTarget.$options._parentVnode.data &&
                    bvEvent.vueTarget.$options._parentVnode.data.attrs &&
                    bvEvent.vueTarget.$options._parentVnode.data.attrs.isDraggable === false) ? false : true;

            if (!isDraggable) {
                return;
            }

            const modalHeader = document.getElementById(`${modalId}___BV_modal_header_`);
            const modalContent = document.getElementById(`${modalId}___BV_modal_content_`);


            if (modalHeader && modalContent) {
                // NOTE: return a function to remove drag feature
                const onModalClose = makeElementDraggable(modalContent, modalHeader);
                numberOfModalOpen += 1;


                root.$on('bv::modal::hide', () => {
                    numberOfModalOpen -= 1;

                    if (modalHeader && onModalClose && !numberOfModalOpen) {
                        // NOTE: add bvModalEvent.preventDefault() to test this
                        onModalClose();
                    }
                })
            }
        })


    }
}

export default initDraggableModal;
